import {
  ModalV3,
  OuraRing4Outline,
  OuraRingGen3Outline,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import CompareModelsStyleCell from './CompareModelsStyleCell';
import CompareModelsTable from './CompareModelsTable';
import CompareModelsTableCell from './CompareModelsTableCell';
import CompareModelsTableRow from './CompareModelsTableRow';

export interface CompareModelsModalProps {
  readonly isOpen: boolean;
  readonly toggleModal: (isOpen: boolean) => void;
}

const CompareModelsModal = ({
  isOpen,
  toggleModal,
}: CompareModelsModalProps): JSX.Element => {
  const t = useTranslations();

  return (
    <ModalV3
      isOpen={isOpen}
      onOpenChange={toggleModal}
      padding="large"
      rounded
      size="large"
    >
      <div data-cy="compare-models-modal-wrapper">
        <div className="mb-6 border-b border-gray-300 pb-6">
          <TypographyV3 Element="h2" variant="h4">
            {t('compare_models_modal_title')}
          </TypographyV3>
        </div>
        <CompareModelsTable>
          <CompareModelsTableRow
            header="compare_models_modal_style_th"
            headerAlign="center"
          >
            <CompareModelsTableCell>
              <CompareModelsStyleCell
                Icon={OuraRing4Outline}
                label="ring_gen_4"
              />
            </CompareModelsTableCell>
            <CompareModelsTableCell>
              <CompareModelsStyleCell
                Icon={OuraRingGen3Outline}
                label="ring_gen_3"
              />
            </CompareModelsTableCell>
          </CompareModelsTableRow>
          <CompareModelsTableRow header="compare_models_modal_design_th">
            <CompareModelsTableCell>
              <ul className="flex flex-col gap-y-7 lg:gap-y-9">
                {t.rich('compare_models_modal_design_or4')}
              </ul>
            </CompareModelsTableCell>
            <CompareModelsTableCell>
              <ul className="flex flex-col gap-y-7 lg:gap-y-9">
                {t.rich('compare_models_modal_design_or3')}
              </ul>
            </CompareModelsTableCell>
          </CompareModelsTableRow>
          <CompareModelsTableRow header="compare_models_modal_sensing_th">
            <CompareModelsTableCell>
              {t.rich('compare_models_modal_sensing_or4', {
                u: (chunks) => chunks, // Remove underline
              })}
            </CompareModelsTableCell>
            <CompareModelsTableCell>
              {t.rich('compare_models_modal_sensing_or3')}
            </CompareModelsTableCell>
          </CompareModelsTableRow>
          <CompareModelsTableRow header="compare_models_modal_battery_th">
            <CompareModelsTableCell>
              {t.rich('compare_models_modal_battery_or4')}
            </CompareModelsTableCell>
            <CompareModelsTableCell>
              {t.rich('compare_models_modal_battery_or3')}
            </CompareModelsTableCell>
          </CompareModelsTableRow>
          <CompareModelsTableRow
            header="compare_models_modal_sizing_th"
            isLastRow
          >
            <CompareModelsTableCell isLastRow>
              {t.rich('compare_models_modal_sizing_or4')}
            </CompareModelsTableCell>
            <CompareModelsTableCell isLastRow>
              {t.rich('compare_models_modal_sizing_or3')}
            </CompareModelsTableCell>
          </CompareModelsTableRow>
        </CompareModelsTable>
      </div>
    </ModalV3>
  );
};

export default CompareModelsModal;
